module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/MultipleAlbums-08e0865bf5d9808538f110baf30fdff4.webp";